import { Mui, MuiStyles } from "@osu/react-ui";
import AuthButton from "../components/AuthButton";
import { NAVBAR_WRAPPER_ID } from "../../util/constants";
import { ROUTE_KEYS, ROUTES } from "../../_configuration/routing/constants";
import NavbarLink from "./Link";
import { useSelector } from "react-redux";
import { selectIsAdmin, selectIsUser } from "../../services/authorization/slices";
import CreateSelect from "./CreateSelect";

const createClasses = (theme) => {
  return {
    appBar: (zIndex) => ({
      top: "0",
      zIndex,
      paddingX: theme.spacing(),
      borderBottom:
        theme.palette.mode === "dark" && `solid 1px ${theme.palette.divider}`,
    }),
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  };
};

const toolbarStyles = {
  display: "flex",
};

const navLinkStyles = (theme) => {
  return {
    mr: theme.spacing(2),
  }
};

export default function Navbar(props = {}) {
  const theme = MuiStyles.useTheme();
  const classes = createClasses(theme);
  const navZ = theme?.zIndex?.appBar
  const paths = useSelector(state => {
    if(selectIsAdmin(state)) {
      return [ROUTE_KEYS.SUBMISSIONS, ROUTE_KEYS.ADMIN]
    } else if (selectIsUser(state)) {
      return [ROUTE_KEYS.SUBMISSIONS]
    }
    return []
  }, (a, b) => a.join() === b.join()) 

  return (
    <Mui.AppBar
      id={NAVBAR_WRAPPER_ID}
      color="inherit"
      position="sticky"
      sx={[
        classes.appBar(navZ),
        {
          clipPath: `inset(.5px -2rem -2rem -2rem)`,
        },
      ]}
    >
      
      <Mui.Toolbar component="nav" aria-label="main" sx={toolbarStyles}>
         <NavbarLink
            sx={navLinkStyles}
            to={"/"}
        >
          Home
        </NavbarLink>
        <CreateSelect sx={navLinkStyles} /> 
        {paths.map((pathKey, idx) => {
          const { path, title } = ROUTES[pathKey] || {};
          if (!path || !title) return false;
          return (
            <NavbarLink
              sx={navLinkStyles}
              key={idx + path.replaceAll("/", "-")}
              to={path.startsWith("/") ? path : `/${path}`}
            >
              {title}
            </NavbarLink>
          );
        })}
        <AuthButton sx={{ ml: "auto" }} />
      </Mui.Toolbar>
    </Mui.AppBar>
  );
}
